import PropTypes from 'prop-types';
import {getNextThemeIcon} from '../utils/theme';
import AccountMenu from './AccountMenu';

function CheckboxLogo() {
    return (
        <svg width="18" height="18" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="7" fill="currentColor"/>
            <rect x="7" y="7" width="18" height="18" rx="3.5" fill="none" stroke="#000" strokeWidth="2"/>
            <polyline points="11,16 14.5,20 21,12" fill="none" stroke="#000" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default function Header({theme, onToggleTheme, onLogout, username, onAccountSettings, onLogoClick}) {
    const nextIcon = getNextThemeIcon(theme);
    const isAuthenticated = !!(onLogout && username);
    return (
        <div className="app-header">
            <button className="header-logo" onClick={onLogoClick} aria-label="Go to home">
                <CheckboxLogo/>
                <span className="header-wordmark">CHECKLISTS GURU</span>
            </button>
            <div className="app-header-right">
                {isAuthenticated ? (
                    <AccountMenu
                        username={username}
                        onLogout={onLogout}
                        onAccountSettings={onAccountSettings}
                        theme={theme}
                        onToggleTheme={onToggleTheme}
                    />
                ) : (
                    <button className="theme-toggle" onClick={onToggleTheme} aria-label="Toggle theme">
                        {nextIcon}
                    </button>
                )}
            </div>
        </div>
    );
}

Header.propTypes = {
    theme: PropTypes.string.isRequired,
    onToggleTheme: PropTypes.func.isRequired,
    onLogout: PropTypes.func,
    username: PropTypes.string,
    onAccountSettings: PropTypes.func,
    onLogoClick: PropTypes.func.isRequired,
};
